class ComponentAccordion extends Theme.Component {
  connectedCallback() {
    console.log('[Accordion] connectedCallback');
    this.events();
  }

  toggleAccordion(detail, element) {
    console.log('[Accordion] toggleAccordion', element);
    const button = element;
    const container = button.closest('.accordion-item');
    const content = container.querySelector('.accordion-item-content');
    const expandIcon = container.querySelector('.accordion-expand');
    const collapseIcon = container.querySelector('.accordion-collapse');
    const isOpen = button.getAttribute('aria-expanded') === 'true';

    button.setAttribute('aria-expanded', String(!isOpen));
    content.style.display = isOpen ? 'none' : 'block';
    if (expandIcon) expandIcon.style.display = isOpen ? 'block' : 'none';
    if (collapseIcon) collapseIcon.style.display = isOpen ? 'none' : 'block';

    console.log('[Accordion] state changed', { isOpen: !isOpen });
  }
}

customElements.define('component-accordion', ComponentAccordion);